import * as v from "@badrap/valita";
import { Temporal } from "temporal-polyfill";

export const $NonNegativeInteger = v
  .number()
  .assert((x) => Number.isSafeInteger(x), "must be a safe integer")
  .assert((x) => x >= 0, "must be a non-negative integer");

export const $PositiveInteger = v
  .number()
  .assert((x) => Number.isSafeInteger(x), "must be a safe integer")
  .assert((x) => x >= 1, "must be a positive integer");

export const $Percentage = v
  .number()
  .assert((x) => Number.isFinite(x), "must be a finite number")
  .assert((x) => x >= 0 && x <= 1, "must be between 0 and 1 inclusive");

export const $ZonedDateTime = v.string().assert((str) => {
  try {
    void Temporal.ZonedDateTime.from(str, {
      overflow: "reject",
      offset: "reject",
      disambiguation: "reject",
    });

    return true;
  } catch {
    return false;
  }
}, "must be a valid `ZonedDateTime`");
